import { Currency } from "@evennt-tech/api-v2-core";

const getCountryByCurrency = (currency: Currency) => {
  switch (currency) {
    case Currency.eur:
      return "NL";
    case Currency.aed:
      return "AE";
    case Currency.aud:
      return "AU";
    case Currency.usd:
      return "US";
    default:
      return "UK";
  }
};

export default getCountryByCurrency;
